import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  { name: "title", label: "Title", showInTable: true },
  { name: "category", label: "Category", showInTable: true },
  {
    name: "image_url",
    label: "Image URL",
    type: "url",
    required: true,
    showInTable: true,
  },
  {
    name: "sort_order",
    label: "Sort Order",
    type: "number",
    showInTable: true,
  },
];

export default function Page() {
  return (
    <AdminShell title="Gallery" subtitle="Photo gallery management">
      <ResourceTable
        table="gallery"
        title="Photo"
        fields={fields}
        searchFields={["title", "category"]}
        orderBy="sort_order"
        orderAsc
      />
    </AdminShell>
  );
}
